var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-collapse",
    {
      staticClass: "evaluation-card",
      attrs: {
        animation: "slide",
        "data-cy": "property-data",
        open: _vm.isOpen,
      },
      scopedSlots: _vm._u([
        {
          key: "trigger",
          fn: function ({ open }) {
            return [
              _c(
                "div",
                {
                  staticClass: "card-header",
                  attrs: { role: "button", "aria-expanded": open.toString() },
                },
                [
                  _c("p", { staticClass: "card-header-title" }, [
                    _vm._v(" Datos del inmueble "),
                  ]),
                  _c(
                    "a",
                    { staticClass: "card-header-icon" },
                    [
                      _c("b-icon", {
                        attrs: { icon: open ? "minus" : "plus" },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c("div", { staticClass: "card-block p-0" }, [
        _c(
          "div",
          { staticClass: "subcard" },
          [
            _c(
              "b-field",
              { attrs: { label: "Tipo de propiedad", horizontal: "" } },
              [
                _c(
                  "b-select",
                  {
                    attrs: {
                      disabled: _vm.readOnly,
                      size: "is-small",
                      placeholder: "Selecciona un tipo de propiedad",
                      "data-cy": "property-type",
                      expanded: "",
                    },
                    model: {
                      value: _vm.localSimulation.offerInputs.propertyType,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localSimulation.offerInputs,
                          "propertyType",
                          $$v
                        )
                      },
                      expression: "localSimulation.offerInputs.propertyType",
                    },
                  },
                  [
                    _c("option", { attrs: { value: "HOME" } }, [
                      _vm._v("HOME"),
                    ]),
                    _c("option", { attrs: { value: "APARTMENT" } }, [
                      _vm._v("APARTMENT"),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _c(
              "b-field",
              { attrs: { label: "Estado", horizontal: "" } },
              [
                _c(
                  "b-select",
                  {
                    attrs: {
                      disabled: _vm.readOnly,
                      size: "is-small",
                      "b-model": "localSimulation.property.isPropertyNew",
                      placeholder: "Selecciona un tipo de propiedad",
                      "data-cy": "is-property-new",
                      expanded: "",
                    },
                    model: {
                      value: _vm.localSimulation.offerInputs.isPropertyNew,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localSimulation.offerInputs,
                          "isPropertyNew",
                          $$v
                        )
                      },
                      expression: "localSimulation.offerInputs.isPropertyNew",
                    },
                  },
                  [
                    _c("option", { attrs: { value: "true" } }, [
                      _vm._v("Nuevo"),
                    ]),
                    _c("option", { attrs: { value: "false" } }, [
                      _vm._v("Usado"),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "subcard is-gray" }, [
          _c(
            "div",
            { staticClass: "subcard-header header-switch" },
            [
              _c(
                "b-field",
                { attrs: { label: "¿Tiene dirección?", horizontal: "" } },
                [
                  _c("b-switch", {
                    attrs: {
                      disabled: _vm.readOnly,
                      size: "is-small",
                      "data-cy": "hasAddress",
                    },
                    model: {
                      value: _vm.localSimulation.generalParams.hasAddress,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localSimulation.generalParams,
                          "hasAddress",
                          $$v
                        )
                      },
                      expression: "localSimulation.generalParams.hasAddress",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.localSimulation.generalParams.hasAddress
            ? _c(
                "div",
                {
                  staticClass: "fields-has-text-right",
                  attrs: { id: "add-address" },
                },
                [
                  _c(
                    "b-field",
                    { attrs: { label: "Calle y número", horizontal: "" } },
                    [
                      _c("b-input", {
                        attrs: {
                          disabled: _vm.readOnly,
                          size: "is-small",
                          type: "text",
                          autocomplete: "off",
                          "data-cy": "main-line-address",
                          expanded: "",
                        },
                        model: {
                          value: _vm.mainLineAddress,
                          callback: function ($$v) {
                            _vm.mainLineAddress = $$v
                          },
                          expression: "mainLineAddress",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    { attrs: { label: "Departamento", horizontal: "" } },
                    [
                      _c("b-input", {
                        attrs: {
                          disabled: _vm.readOnly,
                          size: "is-small",
                          type: "text",
                          autocomplete: "off",
                          "data-cy": "secondary-line-address",
                          expanded: "",
                        },
                        model: {
                          value: _vm.secondaryLineAddress,
                          callback: function ($$v) {
                            _vm.secondaryLineAddress = $$v
                          },
                          expression: "secondaryLineAddress",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    { attrs: { label: "Comuna/Distrito", horizontal: "" } },
                    [
                      _c("b-input", {
                        attrs: {
                          disabled: _vm.readOnly,
                          size: "is-small",
                          type: "text",
                          autocomplete: "off",
                          expanded: "",
                        },
                        model: {
                          value: _vm.localSimulation.offerInputs.district,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.localSimulation.offerInputs,
                              "district",
                              $$v
                            )
                          },
                          expression: "localSimulation.offerInputs.district",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    { attrs: { label: "Ciudad", horizontal: "" } },
                    [
                      _c("b-input", {
                        attrs: {
                          disabled: _vm.readOnly,
                          size: "is-small",
                          autocomplete: "off",
                          type: "text",
                          expanded: "",
                        },
                        model: {
                          value: _vm.cityAddress,
                          callback: function ($$v) {
                            _vm.cityAddress = $$v
                          },
                          expression: "cityAddress",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    { attrs: { label: "País", horizontal: "" } },
                    [
                      _c("b-input", {
                        attrs: {
                          disabled: _vm.readOnly,
                          size: "is-small",
                          type: "text",
                          autocomplete: "off",
                          expanded: "",
                        },
                        model: {
                          value: _vm.countryAddress,
                          callback: function ($$v) {
                            _vm.countryAddress = $$v
                          },
                          expression: "countryAddress",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "subcard is-gray" }, [
          _c(
            "div",
            { staticClass: "subcard-header header-switch" },
            [
              _c(
                "b-field",
                { attrs: { label: "¿Es inmobiliaria?", horizontal: "" } },
                [
                  _c("b-switch", {
                    attrs: {
                      disabled: _vm.readOnly,
                      "data-cy": "hasRealEstate",
                      size: "is-small",
                    },
                    model: {
                      value: _vm.localSimulation.generalParams.hasRealEstate,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localSimulation.generalParams,
                          "hasRealEstate",
                          $$v
                        )
                      },
                      expression: "localSimulation.generalParams.hasRealEstate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.localSimulation.generalParams.hasRealEstate
            ? _c(
                "div",
                {
                  staticClass: "fields-has-text-right",
                  attrs: { id: "add-real-state" },
                },
                [
                  _c(
                    "b-field",
                    { attrs: { label: "Nombre inmobiliaria", horizontal: "" } },
                    [
                      _c("b-autocomplete", {
                        attrs: {
                          disabled: _vm.readOnly,
                          data: _vm.filteredRealEstates(),
                          clearable: !_vm.readOnly,
                          size: "is-small",
                          "keep-first": true,
                          "data-cy": "real-estate-name",
                        },
                        on: {
                          typing: _vm.getRealEstateName,
                          select: (option) => (_vm.selectedRealEstate = option),
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "empty",
                              fn: function () {
                                return [
                                  _vm._v("No se han encontrado resultados"),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3933884493
                        ),
                        model: {
                          value: _vm.realEstate,
                          callback: function ($$v) {
                            _vm.realEstate = $$v
                          },
                          expression: "realEstate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    { attrs: { label: "Nombre de proyecto", horizontal: "" } },
                    [
                      _c("b-autocomplete", {
                        attrs: {
                          disabled: _vm.readOnly,
                          data: _vm.filteredProjects(),
                          clearable: !_vm.readOnly,
                          size: "is-small",
                          "keep-first": true,
                          "data-cy": "project-name",
                        },
                        on: {
                          typing: _vm.getProjectName,
                          select: (option) => (_vm.selectedProject = option),
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "empty",
                              fn: function () {
                                return [
                                  _vm._v("No se han encontrado resultados"),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3933884493
                        ),
                        model: {
                          value: _vm.project,
                          callback: function ($$v) {
                            _vm.project = $$v
                          },
                          expression: "project",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    {
                      attrs: {
                        label: _vm.$t("deliveryDate"),
                        horizontal: "",
                        expanded: "",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "field has-addons" },
                        [
                          _c("p", { staticClass: "control" }, [
                            _c(
                              "a",
                              { staticClass: "button is-static" },
                              [
                                _c("b-icon", {
                                  attrs: {
                                    icon: "calendar-days",
                                    size: "is-small",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c("b-datepicker", {
                            attrs: {
                              disabled: _vm.readOnly,
                              locale: "es-ES",
                              size: "is-small",
                              placeholder: "Selecciona una fecha",
                              "date-formatter": (d) =>
                                d ? _vm.formatDate(d) : "",
                            },
                            model: {
                              value: _vm.deliveryDate,
                              callback: function ($$v) {
                                _vm.deliveryDate = $$v
                              },
                              expression: "deliveryDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
        _c(
          "div",
          { staticClass: "subcard" },
          [
            _c("BInputExpanded", {
              attrs: {
                disabled: _vm.readOnly,
                label: "Valor de la propiedad",
                placeholder: "ingrese valor de la propiedad",
                prefix: "UF",
                size: "is-small",
                "prefix-position": "left",
                "data-cy": "propertyValue",
              },
              model: {
                value: _vm.localSimulation.offerInputs.commercialValue,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.localSimulation.offerInputs,
                    "commercialValue",
                    $$v
                  )
                },
                expression: "localSimulation.offerInputs.commercialValue",
              },
            }),
            _c("BInputExpanded", {
              attrs: {
                disabled: _vm.readOnly,
                label: "Tasación",
                placeholder: "Ingresa tasación",
                prefix: "UF",
                size: "is-small",
                "prefix-position": "left",
                "data-cy": "appraisal",
              },
              model: {
                value: _vm.localSimulation.offerInputs.appraisal,
                callback: function ($$v) {
                  _vm.$set(_vm.localSimulation.offerInputs, "appraisal", $$v)
                },
                expression: "localSimulation.offerInputs.appraisal",
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }